/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Deaerator } from "./modelDeaerator";

class ControllerDeaerator extends ControllerModel {
  constructor() {
    super("ControllerDeaerator");
    
    this.setNewNode = (callback) => {
      let _deaerator = new Deaerator();
      _deaerator.decorate(callback);

      this.addNode(_deaerator);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _deaerator = new Deaerator();
      _deaerator.copyFrom(node);
      _deaerator.decorate(callback);
      this.addNode(_deaerator)
    }

    this.getProperties = async (node) => {
      let n = new Deaerator();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Deaerator();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerDeaerator };
